import { render } from "./AppDropdown.vue?vue&type=template&id=ef8871c2"
import script from "./AppDropdown.vue?vue&type=script&lang=js"
export * from "./AppDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__